<template lang="pug">
  .crud
    #access(v-if="has_permission")
      modal-finish-project(:form="form")
      modal-in-orders-detail(:detail="form")
      modal-update-purchase-order(:title="'Update purchase order'" :form="form")
      modal-delivery(:delivery="delivery")
      modal-select-contact(:project_id='project_id', :contacts_flag='contacts_flag', :selected_contacts='selected_contacts')
      .container-fluid
        vm-row.heading(vm-w="12")
          vm-col(vm-type="flex" vm-align="center" vm-lg=6 vm-sm=6)
            .list-title-cont
              .title-c
                h2 {{ $t('strings.in_order') }}
                stage-indicator(color="#734B6D")
              span {{ $t('strings.in_order_description') }}
            div(style="display:none;")
              vm-button(type="default" icon="list")
              vm-button(type="default" icon="grid" color="rgba(var(--gray),1)")
          vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-lg=6 vm-sm=6)
            div
              vm-button(icon="file-text-outline" @click="printReportDates") {{ $t('strings.report_dates') }}
              vm-tooltip(:text="$t('strings.options')" delay=".5s")
                vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
                  vm-button(type="border" icon="more-horizotnal" color="#afbbc6")

                  vm-dropdown-menu
                    vm-dropdown-item.d-flex.justify-content-between(@click="printReport")
                      vm-icon(icon="printer-outline")
                      slot &nbsp;{{ $t('strings.print') }}
                    //- More options
                        Agrega mas acciones para colecciones de datos
        vm-row(vm-w="12")
          vm-col.card(vm-sm=12)
            vm-table(max-height="350px" :data="inOrders")
              template(slot="header")
                .d-flex.justify-content-between
                  vm-input(ref="search" icon="search" size="small" :placeholder="searchPlaceholder" v-model="filters.where.param" @keyup.enter="applyFilter(filters)"  width="300px")
                  div
                    vm-tooltip(:text="$t('strings.filters')" delay=".5s")
                      vm-dropdown(ref='dropdown' vm-custom-content vm-trigger-click vm-trigger-outside-click)
                        vm-button(type="default" icon="funnel-outline" size="small")

                        vm-dropdown-menu(class="filters")
                          .heading.d-flex.justify-content-between
                            h4 {{ $t('strings.filters') }}
                            vm-button(type="flat" size="small" @click="clearFilter") {{ $t('strings.clear') }}
                          vm-select.filter(:placeholder="$t('strings.multiple')" multiple autocomplete label="Changes order" v-model="filters.whereIn.additional")
                            vm-select-item(:key="index" :value="item.value" :text="item.text" v-for="(item,index) in additional")
                          //- Add filters
                              Agrega los filtros que prefieras por ejemplo:
                              vm-select.filter(:placeholder="$t('strings.multiple')" multiple autocomplete label="Status" v-model="filters.whereIn.status")
                                vm-select-item(:key="index" :value="item.value" :text="item.text" v-for="(item,index) in status")
                              vm-date-picker.filter(type="daterange" :label="$t('in_orders.created_at')" :placeholder="$t('strings.select_date')" @on-change="handleChange" :value="filters.betweenDates.created_at")
                              vm-select.filter(url="suppliers" columns="name,etc" :placeholder="$t('strings.multiple')" multiple autocomplete :label="$t('purchase_orders.supplier_id')" v-model="filters.whereIn.supplier_id" @input-change="autoCompleteFunc")
                                vm-select-item(:key="index" :value="item.id" :text="item.name" v-for="(item,index) in purchaseOrdersCatalog.suppliers")

                              NOTA: (agregar clase .filter)
                          .filter.d-flex
                            vm-button(@click="applyFilter(filters)") {{ $t('strings.apply') }}
                    vm-order-by(:sort-by-text="$t('strings.order_by')" placeholder="Ninguno" :data="columnsOrderBy" v-model="filters.orderBy" @change="changeOrderBy(filters)" size="small" width="200px" :serializer="item => $t('projects.'+ item)")
              template(slot="thead")
                vm-th(:key="index" v-for="(column, index) in columns") {{ $t('projects.' + column) }}
              template(slot-scope="{data}")
                vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
                  vm-td(:data="data[indextr][column]" :key="index" v-for="(column, index) in columns")
                    div(@click="editInOrder(data[indextr], tr)")
                      slot(v-if="column == 'total' || column == 'amount'")  {{data[indextr][column] | currency }}
                      slot(v-if="column == 'updated_at' || column == 'delivery_deadline' || column == 'previous_delivery_deadline'")  {{data[indextr][column] | moment("DD MMMM YYYY") }}
                      slot(v-if="column != 'updated_at' && column != 'delivery_deadline' && column != 'previous_delivery_deadline' && column != 'project_on_pause' && column != 'total' && column != 'amount' && column != 'additional' && column != 'customer'") {{data[indextr][column]}}
                      vm-status-indicator(v-if="column == 'project_on_pause'" :pulse="data[indextr]['project_on_pause'] !== 'Activo'" :color="colorStatus(data[indextr]['project_on_pause'])") {{data[indextr]['pause']}}
                      slot(v-if="column == 'customer'") {{ data[indextr]['customer']['name'] }}
                      slot(v-if="column == 'changes_orders'") {{ data[indextr]['additional'] == 1 ? 'SI' : 'NO' }}
                  vm-td
                    vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
                      vm-button(type="flat" icon="more-horizotnal" color="#afbbc6")
                      vm-dropdown-menu(v-if="data[indextr]['stage'] === 3")
                        .dropdown
                          vm-dropdown-item.d-flex.justify-content-between(v-if="quotation_files_index_permission && !customer && !$auth.check('Employee')" @click="editOrder(data[indextr])")
                            vm-icon(icon="edit-2-outline")
                            slot &nbsp;{{ $t('strings.edit_project') }}
                          vm-dropdown-item.d-flex.justify-content-between(@click="editInOrder(data[indextr], tr)")
                            vm-icon(icon="eye-outline")
                            slot &nbsp;{{ $t('strings.view') }}
                          vm-dropdown-item.d-flex.justify-content-between(@click="openViewer(data[indextr], tr)")
                            vm-icon(icon="file-text-outline")
                            slot &nbsp;{{ $t('projects.purchase_order') }}
                          vm-dropdown-item.d-flex.justify-content-between(@click="atModal(data[indextr], tr)" v-if="!$auth.check('Employee')")
                            vm-icon(icon="file-text-outline")
                            slot &nbsp;{{ data[indextr]['file_order_url'] === "" ? $t('projects.upload_purchase_order') : $t('projects.update_purchase_order') }}
                          vm-dropdown-item.d-flex.justify-content-between(v-if="quotation_files_index_permission && !customer && !$auth.check('Employee')" @click="addDeadline(data[indextr])")
                            vm-icon(icon="edit-2-outline")
                            slot &nbsp;{{ $t('projects.new_deadline') }}
                          vm-dropdown-item.d-flex.justify-content-between(v-if="quotation_files_index_permission && !$auth.check('Employee')" @click="attachment(data[indextr])")
                            vm-icon(icon="file-text-outline")
                            slot &nbsp;{{ $t('strings.quotations') }}
                          vm-dropdown-item.d-flex.justify-content-between(v-if="data[indextr]['project_on_pause'] == 0 && !customer && !$auth.check('Employee')" @click="setActionInOrder(data[indextr], 'pause')")
                            vm-icon(icon="pause-circle-outline")
                            slot &nbsp;{{ $t('strings.pause') }}
                          vm-dropdown-item.d-flex.justify-content-between(v-if="data[indextr]['project_on_pause'] == 1 && !customer && !$auth.check('Employee')" @click="setActionInOrder(data[indextr], 'play')")
                            vm-icon(icon="play-circle-outline")
                            slot &nbsp;{{ $t('strings.play') }}
                          vm-dropdown-item.d-flex.justify-content-between(v-if="finish_project_store_permission && data[indextr]['status'] != 5 && data[indextr]['delivery_deadline'] && !$auth.check('Employee')" @click="viewModalFinished(data[indextr])")
                            vm-icon(icon="done-all-outline")
                            slot &nbsp;{{ $t('strings.finished') }}
                          vm-dropdown-item.d-flex.justify-content-between(v-if="data[indextr]['project_on_pause'] != 2 && !$auth.check('Customer') && !$auth.check('Employee')" @click="cancelProject(data[indextr], 'cancel')")
                            vm-icon(icon="close-outline")
                            slot &nbsp;{{ $t('strings.cancel') }}
                          vm-dropdown-item.d-flex.justify-content-between(@click="deleteInOrderConfirm(data[indextr])" v-if="$auth.check('Admin') && !$auth.check('Employee')")
                            vm-icon(icon="trash-2-outline")
                            slot &nbsp;{{ $t('strings.delete') }}
                          vm-dropdown-item.d-flex.justify-content-between(@click="selectContact(data[indextr])" v-if="canSelectContacts(data[indextr].customer_id) && !$auth.check('Employee')")
                            vm-icon(icon="people-outline")
                            slot &nbsp;{{ $t('strings.select_contacts') }}
                          vm-dropdown-item.d-flex.justify-content-between(@click="$router.push(`/rfis/project/${data[indextr]['id']}`)")
                            vm-icon(icon="file-outline")
                            slot &nbsp;{{ $t('strings.view_rfis') }}                          
            vm-pagination(:total="pagination.totalPages" v-model="currentPage" goto)
            //- transition(name="enter")
            //-   .total-records(v-if="total>0") Total: {{ total | currency }}
    #no-access(v-else)
      access-denied
</template>

<script>
import moment from 'moment'
import ModalUpdatePurchaseOrder from '@/components/in-order/ModalUpdatePurchaseOrder.vue'
import parseVuexObject from '@/utils/parseVuexObject'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('InOrders')

export default {
  name: 'InOrders',
  components: {
    ModalUpdatePurchaseOrder,
    ModalFinishProject: () => import('@/components/modals/ModalFinishProject.vue'),
    ModalInOrdersDetail: () => import('@/components/modals/ModalInOrdersDetail.vue'),
    ModalDelivery: () => import('@/components/in-order/ModalDelivery.vue'),
    StageIndicator: () => import('@/components/aditionals/StageIndicator.vue'),
    AccessDenied: () => import('@/components/aditionals/AccessDenied.vue'),
    ModalSelectContact: () => import('@/components/modals/ModalSelectContact.vue')
  },
  data: () => ({
    form: {},
    delivery: {},
    permissions: {},
    currentPage: 1,
    has_permission: true,
    customer: false,
    delivery_deadline_update_permission: true,
    quotation_files_index_permission: true,
    finish_project_store_permission: true,
    selected: [],
    contacts_flag: [],
    selected_contacts: [],
    columns: [
      'id',
      'project_name',
      'customer',
      'amount',
      'delivery_deadline',
      'updated_at',
      'changes_orders',
      'total_remissions',
      'project_on_pause'
    ],
    columnsOrderBy: [
      'amount',
      'project_name'
    ],
    additional: [
      {
        text: 'NO',
        value: 0
      },
      {
        text: 'SI',
        value: 1
      }
    ],
    project_on_pause: [
      {
        text: 'NO',
        value: 0,
        color: 'success'
      },
      {
        text: 'SI',
        value: 1,
        color: 'warning'
      },
      {
        text: 'SI',
        value: 2,
        color: 'danger'
      }
    ],
    filters: {
      // Nota: Estos campos se parsearan en el v-model de los filtros. Ver linea 60
      where: {
        project_name: '',
        param: ''
      },
      whereIn: {
        additional: []
      },
      whereBetween: {
        // Agrega las columnas que se filtraran entre paramentros ejemplo: priece: []
      },
      betweenDates: {
        // Agrega las columnas que se filtraran entre fechas: created_at: []
      },
      orderBy: ''
    },
    filtersClear: {}
  }),
  async created () {
    this.checkPermissionView('in_orders.index')
    this.filtersClear = parseVuexObject(this.filters)
    await this.getInOrders(1)
  },
  methods: {
    ...mapActions([
      'setModalUpdatePurchaseOrderVisible',
      'loadInOrders',
      'loadCatalog',
      'actionInOrder',
      'printReport',
      'printReportDates',
      'applyFilter',
      'clearFilter',
      'deleteInOrder',
      'setModalFinishedProjectVisible',
      'setModalVisible',
      'setModalDeliveryVisible',
      'setModalContactVisible',
      'loadEmployees'
    ]),
    changeOrderBy (data) {
      if (data.orderBy) {
        let [field, order] = data.orderBy.split(',')
        if (order === 'dsc') {
          order = 'desc'
        }
        data.orderBy = `${field},${order}`
      }
      this.applyFilter(data)
    },
    openViewer (project) {
      this.$viewer.show({
        urlFile: project.file_order_url,
        mime: 'application/pdf',
        color: '#FFF'
      })
    },
    attachment (project) {
      this.$router.push(`/quotation-files/${project.id}`)
    },
    checkPermissionView (permission) {
      this.has_permission = this.$auth.user().view_permissions.findIndex(e => e.name === permission) > -1
      this.delivery_deadline_update_permission = this.$auth.user().view_permissions.findIndex(e => e.name === 'delivery_deadline.update') > -1
      this.finish_project_store_permission = this.$auth.user().view_permissions.findIndex(e => e.name === 'finish_projects.store') > -1
      this.quotation_files_index_permission = this.$auth.user().view_permissions.findIndex(e => e.name === 'quotation_files.index') > -1
      this.customer = this.$auth.user().view_roles.findIndex(e => e === 'Customer') > -1
    },
    addDeadline (record) {
      this.setModalDeliveryVisible(true)
      this.delivery = { ...record }
    },
    viewModalFinished (project) {
      this.form = project
      this.form.completion_date = moment().format('YYYY-MM-DD')
      this.setModalFinishedProjectVisible(true)
    },
    colorStatus (code) {
      return this.project_on_pause.find(e => e.value === parseInt(code))['color']
    },
    setFocusSearch () {
      this.$refs.search.$refs.vminput.focus()
    },
    editShortcut () {
      if (this.selected.length === 0 || this.selected.length > 1) return
      const idx = this.inOrders.findIndex(u => u.id === this.selected[0].id)
      this.editInOrder(this.selected[0], idx)
    },
    editInOrder (inOrder, index) {
      this.$router.push(`/in-orders/${inOrder.id}`)
    },
    editOrder (proyect) {
      this.form = proyect
      this.setModalVisible(true)
    },
    async setActionInOrder (record, action) {
      record.id && this.actionInOrder({ id: record.id, action })
    },
    async cancelProject (record, action) {
      let t = this
      this.auxCancelProject = () => {
        t.actionInOrder({ id: record.id, action })
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.cancel_modal'),
        text: this.$t('front.cancel_confirmation2', { model: this.$t('strings.project'), attribute: this.$t(record.project_name) }),
        accept: this.auxCancelProject
      })
    },
    async deleteInOrderConfirm (inOrder) {
      let t = this
      this.auxDeleteInOrder = () => {
        t.deleteInOrder(inOrder).then(() => { t.selected = [] })
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', { model: this.$t('strings.project'), attribute: this.$t(inOrder.id) }),
        accept: this.auxDeleteInOrder
      })
    },
    async selectContact (quote) {
      this.project_id = quote.id
      this.contacts_flag = []
      this.selected_contacts = []
      let set1 = []
      let t = this
      await this.loadEmployees({ employer: quote.customer_id })
      setTimeout(() => {
        if (t.employees.length) {
          set1 = new Set(t.employees.map(e => e.id))
          t.contacts_flag = quote.contacts.map(e => !!set1.has(e.id))
          t.selected_contacts = quote.contacts.map(e => e.id)
          t.setModalContactVisible(true)
        } else {
          t.$vm.dialog({
            color: 'primary',
            title: t.$t('projects.contact'),
            text: 'No employees found'
          })
        }
      }, 1000)
    },
    canSelectContacts (id) {
      if (this.customer) {
        return this.customer.id === id
      }
      return true
    },
    async getInOrders (page) {
      this.loadInOrders({ page })
    },
    autoCompleteFunc (value, url) {
      this.loadCatalog({ filter: value, url: url })
    },
    newObjectFuncModal (value) {
      //
    },
    newObjectFuncView (value) {
      //
    },
    handleChange (date) {
      // this.filters.betweenDates.created_at = date
    },
    hiddeDrop () {
      let [dropdownMenu] = this.$refs.dropdown.$children.filter((item) => {
        return item.hasOwnProperty('dropdownVisible')
      })
      dropdownMenu.dropdownVisible = false
    },
    atModal (record) {
      this.form = record
      this.setModalUpdatePurchaseOrderVisible(true)
    }
  },
  computed: {
    ...mapGetters([
      'inOrders',
      'isModalUpdatePurchaseOrderVisible',
      'pagination',
      'filterParams',
      'employees'
    ]),
    searchPlaceholder () {
      let t = this
      let concatColumns = Object.keys(this.filters.where).reduce((str, column, index) => {
        if (column !== 'param' && index < Object.keys(t.filters.where).length - 2) return (index > 0) ? `${str}, $\{t.$t('inOrders.' + column)}` : `${str} ${t.$t('inOrders.' + column)}`
        return str
      }, '')
      return this.$t('strings.search', { attribute: this.$t('strings.in_order'), columns: concatColumns, column: this.$t('projects.' + Object.keys(this.filters.where)[Object.keys(t.filters.where).length - 2]) })
    }
  },
  watch: {
    currentPage (currentPage) {
      this.getInOrders(currentPage)
    },
    filterParams (filter) {
      this.hiddeDrop()
      filter.length === 0 && (this.filters = parseVuexObject(this.filtersClear))
      this.selected = []
      this.currentPage = 1
      this.getInOrders(this.currentPage)
    }
  }
}
</script>

<style lang="scss">
.filters {
  .filter {
    padding: 5px 10px;
    width: 250px;
  }
}
.con-vm-tooltip {
  display: inline-block;
  position: relative;
}
.vm-table--header {
  padding: 10px;
  span:nth-child(1)  {
    width: 100%;
  }
  .input-select-con{
    span {
      width: auto !important;
    }
  }
  .justify-content-between {
    div:last-child {
      .vm-button {
        margin: 0 3px;
      }
      .vm-con-dropdown {
        float: left;
      }
      .con-select {
        display: inline-block;
        input {
          height: 32px;
        }
      }
    }
  }
}
.image_index {
  z-index: 999990 !important;
}
.dropdown  {
  width: 250px;
  height: 250px;
  overflow: auto;
}
.list-title-cont {
  display: flex;
  flex-direction: column;
  .title-c {
    display: flex;
    align-items: center;
  }
}
</style>
